
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import http from '../../../utils/http';

type Payload = {
  data: any;
}

export function useSaveProviderPracticeRegistration() {
  const queryClient = useQueryClient();
  const { mutate, data, variables, reset, ...rest } = useMutation({
    mutationKey: ['Save Provider Practice Registration'],
    mutationFn: async ({ data }: Payload) => {
      const response = await http.post("/practice-reg/register", {
        ...data
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Save Provider Practice Registration'] as const});
    },

    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(
          error?.response?.data?.error || error.response?.statusText,
        );
      } else {
        toast.error(
          error?.message
          || "Error creating template form",
        );
      }
    },
  });

  return {
    saveProviderPractionReg: mutate,
    providerPractionReg: data,
    variables,
    ...rest,
  };
}
